import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    '政府服务',
    '节能咨询',
    '双碳咨询',
    '绿色制造',
    '碳资产管理',
    '能源管理系统'
  ];

  const solutions = [
    '减排量开发',
    '碳资产交易',
    '综合能源服务',
    '供应链管理',
    '碳资产区块链',
    '碳金融服务'
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="/src/assets/images/logo.png" 
                alt="捷碳科技" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              致力于提供低碳技术解决方案，帮助企业实现碳减排目标，推动可持续发展和绿色创新，构建智能化碳管理平台。
            </p>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
            
            {/* WeChat QR Code */}
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3">关注公众号</h4>
              <div className="flex items-center space-x-4">
                <img
                  src="/src/assets/images/wechat-qr.jpg"
                  alt="微信公众号二维码"
                  className="w-20 h-20 rounded-lg"
                />
                <div>
                  <p className="text-gray-300 text-sm mb-1">扫码关注微信公众号</p>
                  <p className="text-gray-400 text-xs">获取最新低碳资讯</p>
                </div>
              </div>
            </div>
            
            {/* 友情链接 */}
            <div>
              <h4 className="text-lg font-semibold mb-3">友情链接</h4>
              <a 
                href="http://www.ceo.sh.cn/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer"
              >
                复洁环保
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">核心服务</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-lg font-semibold mb-6">解决方案</h3>
            <ul className="space-y-3">
              {solutions.map((solution) => (
                <li key={solution}>
                  <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                    {solution}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="text-gray-400 text-sm text-center md:text-left">
              <div className="mb-2">© {currentYear} 捷碳科技. 保留所有权利.</div>
              <div className="space-y-1">
                <div>沪ICP备2022031562号-1</div>
                <div>沪公网安备31011502400610号</div>
              </div>
            </div>
            <div className="flex flex-wrap justify-center md:justify-end gap-6 text-sm text-gray-400">
              <Link to="/terms" className="hover:text-emerald-400 transition-colors cursor-pointer">使用条款</Link>
              <Link to="/privacy" className="hover:text-emerald-400 transition-colors cursor-pointer">隐私政策</Link>
              <Link to="/cookies" className="hover:text-emerald-400 transition-colors cursor-pointer">Cookie政策</Link>
              <button onClick={scrollToContact} className="hover:text-emerald-400 transition-colors cursor-pointer">联系我们</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
